module.exports = __webpack_public_path__ + "img/source05_03.6fde6837.png";